import Vue from 'vue'
import App from './App'
import router from './router'

// vue-js-modal
import VModal from 'vue-js-modal'
Vue.use(VModal)

import Lightbox from 'vue-pure-lightbox'
Vue.use(Lightbox)

import header from './common/header'
import footer from './common/footer'

import {firebase, firebaseui, firebaseuiConfig, firestoreDB} from '@/common/firebaseConfig.js'

Vue.component('head-component', header )
Vue.component('foot-component', footer )

let app;

firebase.auth().onAuthStateChanged((user)=>
  {
    if(!app) {
      app = new Vue({
        el: '#app',
        // store : store,
        router,
        template: '<App/>',
        components:  { App }
      });
    }
  })
